import { AxiosError } from "axios";

import store from "@/store";
import axiosProxyHttpClient from "@/axios-proxy-http-client";

import { ResponseInterceptor } from "@/types/http/response-interceptor";

import { FalconError } from "@/interfaces/http/falcon-error";

import { FalconErrorCode } from "@/enums/http/falcon-error-code.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon session refresh interceptor
 */
export const sessionRefreshInterceptor: ResponseInterceptor = {
  async onRejected(error: AxiosError): Promise<any> {
    if (
      (error.response?.data as FalconError).error?.code ===
      FalconErrorCode.ERR_SESSION
    ) {
      await store.dispatch("auth/refreshToken");
      return new Promise(resolve =>
        resolve(axiosProxyHttpClient(error.config))
      );
    } else {
      return Promise.reject(error);
    }
  }
};
